import React, { useState, useEffect, useContext } from "react";
import { EasyTrackingModal } from "../../../modal/EasyTrackingModal";
import { Plan } from "./Plan";
import { PlanArrepentimientoModal } from "./PlanArrepentimientoModal";
import Select from "react-select";
import { AppContext } from "../../../../Context/Context";
import { useHistory } from "react-router";

const options = [
    { value: "Todos", label: "Todos" },
    { value: "Ahorrista", label: "Ahorrista" },
    { value: "Ahorrista - EN MORA", label: "Ahorrista - EN MORA" },
    { value: "Adjudicado", label: "Adjudicado" },
    { value: "Adjudicado - EN MORA", label: "Adjudicado - EN MORA" },
    { value: "Renunciado/Rescindido", label: "Renunciado/Rescindido" }
];

const colourStyles = {
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
        const color = "#A21C41";
        return {
            ...styles,
            backgroundColor: isDisabled
                ? null
                : isSelected
                ? data.color
                : isFocused
                ? color
                : null,
            color: isDisabled
                ? "#000"
                : isSelected
                ? "#000"
                : isFocused
                ? "#fff"
                : "#000",
            cursor: isDisabled ? "not-allowed" : "default",

            ":active": {
                ...styles[":active"],
                backgroundColor:
                    !isDisabled && (isSelected ? data.color : color)
            }
        };
    }
};

export const SeleccionPlan = ({ match }) => {
    const [planes, setPlanes] = useState([]);
    const [planesToShow, setPlanesToShow] = useState([]);
    const [isLoading, setLoading] = useState(true);
    const [usuarioData, setUsuarioData] = useState({});
    const [selectedPlan, setSelectedPlan] = useState();
    const [value, setValue] = useState("Todos");

    const [state] = useContext(AppContext);
    const history = useHistory();
    const [isEffectInitialized, setEffectInitialized] = useState(false);

    const easyTrackingModalEnabled = state?.easyTrackingModal === true;

    const fetchPlanesData = async () => {
        try {
            setLoading(true);
            let fetchedPlanes = [];

            if (match.params.CUIT) {
                // Arrepentimiento flow
                if (match.params.CUIT === state.arrepentimientoCUIT) {
                    const tokenLogin = atob(sessionStorage.getItem("dttk"));
                    const endpoint = await fetch("/api/show_endpoints/wsmisplanescorto").then(res => res.json());
                    const brand = await fetch("/api/get_brand").then(res => res.json());

                    const response = await fetch(
                        `${endpoint.url_base}${endpoint.url_variable}?CUIT=${state.arrepentimientoCUIT}&Brand=${brand.nombre}&TokenLogin=${tokenLogin}`
                    );
                    const result = await response.json();

                    if (!result || !Object.keys(result).length) {
                        history.push("/login_mi_plan");
                        return;
                    }

                    setUsuarioData(result.Usuario);

                    fetchedPlanes = result.Usuario.Datos.Planes.Plan || [];
                } else {
                    history.replace("/");
                    return;
                }
            } else if (state.data) {
                // MiPlan flow
                fetchedPlanes = state.data.Usuario.Datos.Planes.Plan || [];
            }

            // Fetch descriptions for all plans
            const updatedPlanes = await Promise.all(
                fetchedPlanes.map(async plan => {
                    const description = await fetch(`/planes_historicos/${plan.CodigoPlan}`).then(res => res.json());
                    return { ...plan, descripcion: description.descripcion };
                })
            );

            setPlanes(updatedPlanes);
            setPlanesToShow(updatedPlanes);
        } catch (error) {
            console.error("Error fetching planes data:", error);
        } finally {
            setLoading(false);
        }
    };

    // Fetch Planes Data
    useEffect(() => {
        if (!isEffectInitialized && (match.params.CUIT || state.data)) {
            fetchPlanesData();
            setEffectInitialized(true);
        }
    }, [match.params.CUIT, state.data, state.arrepentimientoCUIT, isEffectInitialized]);

    useEffect(() => {
        if (planes && value !== "Todos") {
            setPlanesToShow(planes.filter(plan => plan.EstadoPlan === value));
        } else {
            setPlanesToShow(planes);
        }
    }, [planes, value]);

    const handleInputChange = e => setValue(e.value);

    const handleOpen = plan => {
        document.querySelector(".form-modalBackdrop").style.opacity = "1";
        document.querySelector(".form-modalBackdrop").style.zIndex = "99999";
        document.querySelector(".form-modalScreen").style.opacity = "1";
        document.querySelector(".form-modalScreen").style.zIndex = "999999";
        setSelectedPlan(plan);
    };

    const handleClose = () => {
        document.querySelector(".form-modalBackdrop").style.opacity = "0";
        document.querySelector(".form-modalBackdrop").style.zIndex = "-1";
        document.querySelector(".form-modalScreen").style.opacity = "0";
        document.querySelector(".form-modalScreen").style.zIndex = "-1";
        setSelectedPlan({});
        history.replace("/");
    };

    const handleCerrarSesion = () => {
        sessionStorage.clear();
        history.replace("/");
    };

    return (
        <div className="seleccionPlan position-relative bg-gris">
            {easyTrackingModalEnabled && <EasyTrackingModal />}
            <div className="seleccionPlan_title_container">
                <div className="title">
                    <h1 style={{ marginLeft: "15px" }}>Selección plan</h1>
                </div>
                <div className="logout">
                    <a onClick={handleCerrarSesion}>Cerrar sesión</a>
                    <img src="/images/header/cerrar-sesion.svg" alt="Cerrar sesión" />
                </div>
            </div>
            <div className="seleccionPlan_container">
                <div className="seleccionPlan_mainDiv">
                    <div className="row">
                        <div className="col-lg-6">
                            <Select
                                styles={colourStyles}
                                options={options}
                                theme={theme => ({
                                    ...theme,
                                    borderRadius: 0,
                                    colors: {
                                        ...theme.colors,
                                        primary25: "#A21C41",
                                        primary: "#D1D1D1"
                                    }
                                })}
                                placeholder={value}
                                onChange={handleInputChange}
                            />
                        </div>
                    </div>
                    <div className="row">
                        {isLoading ? (
                            <div className="spinner-loader w-100 d-flex justify-content-center">
                                <div className="spinner-border text-amarillo text-warning mt-dbhf mb-doub align-self-center" role="status">
                                </div>
                            </div>
                        ) : planesToShow.length > 0 ? (
                            planesToShow.map(plan => (
                                <Plan
                                    key={plan.Id}
                                    id={plan.Id}
                                    percentage={Math.round((plan.Resumen.Pagas / plan.Resumen.Total) * 100) || 0}
                                    type={plan.EstadoPlan}
                                    plan={plan.descripcion}
                                    grupo={plan.Grupo}
                                    orden={plan.Orden}
                                    botonArrepentimiento={{ plan, handleOpen, noPoint: !!match.params.CUIT }}
                                    modelo={plan.ModeloSuscripcion}
                                    fechaIngreso={plan.FechaIngreso}
                                    suscripcion={plan.Solicitud}
                                />
                            ))
                        ) : (
                            <div className="seleccionPlan_mainDiv_noPlan">No existen planes con el estado seleccionado</div>
                        )}
                    </div>
                </div>
            </div>
            <PlanArrepentimientoModal
                handleClose={handleClose}
                usuarioData={usuarioData}
                selectedPlan={selectedPlan}
                setPlanesToShow={setPlanesToShow}
            />
        </div>
    );
};
